module.exports = __webpack_public_path__ + "img/yw_hdgl.5c2c5abc.svg";